module.exports = __webpack_public_path__ + "static/media/bars.690e5640.svg";


//////////////////
// WEBPACK FOOTER
// ./src/component/chordSelect/bars.svg
// module id = 21
// module chunks = 0